/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type DeleteTeamAuthTeamsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class DeleteTeamAuthTeamsResponse429ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: DeleteTeamAuthTeamsResponse429ResponseBodyData;

  constructor(
    err: DeleteTeamAuthTeamsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteTeamAuthTeamsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type DeleteTeamAuthTeamsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class DeleteTeamAuthTeamsResponse409ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: DeleteTeamAuthTeamsResponse409ResponseBodyData;

  constructor(
    err: DeleteTeamAuthTeamsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteTeamAuthTeamsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type DeleteTeamAuthTeamsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class DeleteTeamAuthTeamsResponse404ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: DeleteTeamAuthTeamsResponse404ResponseBodyData;

  constructor(
    err: DeleteTeamAuthTeamsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteTeamAuthTeamsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type DeleteTeamAuthTeamsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class DeleteTeamAuthTeamsResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: DeleteTeamAuthTeamsResponseResponseBodyData;

  constructor(
    err: DeleteTeamAuthTeamsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteTeamAuthTeamsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type DeleteTeamAuthTeamsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class DeleteTeamAuthTeamsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: DeleteTeamAuthTeamsResponseBodyData;

  constructor(
    err: DeleteTeamAuthTeamsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteTeamAuthTeamsResponseBody";
  }
}

/**
 * Bad request
 */
export type DeleteTeamResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class DeleteTeamResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: DeleteTeamResponseBodyData;

  constructor(
    err: DeleteTeamResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteTeamResponseBody";
  }
}

/** @internal */
export const DeleteTeamAuthTeamsResponse429ResponseBody$inboundSchema:
  z.ZodType<DeleteTeamAuthTeamsResponse429ResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new DeleteTeamAuthTeamsResponse429ResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type DeleteTeamAuthTeamsResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteTeamAuthTeamsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    DeleteTeamAuthTeamsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteTeamAuthTeamsResponse429ResponseBody
  > = z.instanceof(DeleteTeamAuthTeamsResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteTeamAuthTeamsResponse409ResponseBody$inboundSchema:
  z.ZodType<DeleteTeamAuthTeamsResponse409ResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new DeleteTeamAuthTeamsResponse409ResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type DeleteTeamAuthTeamsResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteTeamAuthTeamsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    DeleteTeamAuthTeamsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteTeamAuthTeamsResponse409ResponseBody
  > = z.instanceof(DeleteTeamAuthTeamsResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteTeamAuthTeamsResponse404ResponseBody$inboundSchema:
  z.ZodType<DeleteTeamAuthTeamsResponse404ResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new DeleteTeamAuthTeamsResponse404ResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type DeleteTeamAuthTeamsResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteTeamAuthTeamsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    DeleteTeamAuthTeamsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteTeamAuthTeamsResponse404ResponseBody
  > = z.instanceof(DeleteTeamAuthTeamsResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteTeamAuthTeamsResponseResponseBody$inboundSchema: z.ZodType<
  DeleteTeamAuthTeamsResponseResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new DeleteTeamAuthTeamsResponseResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type DeleteTeamAuthTeamsResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteTeamAuthTeamsResponseResponseBody$outboundSchema: z.ZodType<
  DeleteTeamAuthTeamsResponseResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteTeamAuthTeamsResponseResponseBody
> = z.instanceof(DeleteTeamAuthTeamsResponseResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const DeleteTeamAuthTeamsResponseBody$inboundSchema: z.ZodType<
  DeleteTeamAuthTeamsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new DeleteTeamAuthTeamsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type DeleteTeamAuthTeamsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteTeamAuthTeamsResponseBody$outboundSchema: z.ZodType<
  DeleteTeamAuthTeamsResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteTeamAuthTeamsResponseBody
> = z.instanceof(DeleteTeamAuthTeamsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const DeleteTeamResponseBody$inboundSchema: z.ZodType<
  DeleteTeamResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new DeleteTeamResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type DeleteTeamResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteTeamResponseBody$outboundSchema: z.ZodType<
  DeleteTeamResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteTeamResponseBody
> = z.instanceof(DeleteTeamResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
